import {assert} from 'Asserts';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {ListWarehouseModelsQuery} from 'insights/warehouse/__generated/ListWarehouseModelsQuery';
import {WarehouseColumnData, WarehouseTableData} from 'insights/warehouse/warehouseModelsDataLayout';

type TagSchema = ExtractByTypename<
  ListWarehouseModelsQuery['warehouseModelListing']['warehouseModels'][number]['tables'][number]['schema'],
  'TagSchemaNode'
>;

export enum FormType {
  BASIC_BIOENTITY = 'BASIC_BIOENTITY',
}

export enum AvailableColumnType {
  BIOENTITY = 'BIOENTITY',
  TEXT = 'TEXT',
}
export interface TextAvailableColumnTypeInfo {
  type: AvailableColumnType.TEXT;
}
export interface BioentityAvailableColumnTypeInfo {
  type: AvailableColumnType.BIOENTITY;
  linkedSchema: TagSchema | null;
}

export type AvailableColumnTypeInfo = BioentityAvailableColumnTypeInfo | TextAvailableColumnTypeInfo;

export interface AvailableColumn {
  alias: string | null;
  columnData: WarehouseColumnData;
  selected: boolean;
  typeInfo: AvailableColumnTypeInfo;
  validationError: string | null;
}
export type AvailableColumnProperties = Partial<Omit<AvailableColumn, 'columnData'>>;

export enum ColumnFilterType {
  EQUALS = 'EQUALS',
  GTE = 'GTE',
  IS_ONE_OF = 'IS_ONE_OF',
  IS_NONE_OF = 'IS_NONE_OF',
  IS_NOT_NULL = 'IS_NOT_NULL',
  IS_NULL = 'IS_NULL',
  LTE = 'LTE',
  NOT_EQUALS = 'NOT_EQUALS',
}

export interface ColumnFilter {
  filteredColumnIndex: number;
  filterType: ColumnFilterType;
  rawValues: string;
  validationError: string | null;
  values: Array<string>;
}

interface BaseSQLTemplateFormState {
  excludeDuplicates: boolean;
  formType: FormType;
}

export interface NonInitializedSQLTemplateFormState extends BaseSQLTemplateFormState {
  selectedTable: null;
}

export interface InitializedSQLTemplateFormState extends BaseSQLTemplateFormState {
  selectedTable: WarehouseTableData;
  availableColumns: Array<AvailableColumn>;
  columnFilters: Array<ColumnFilter>;
}

export type SQLTemplateFormState = NonInitializedSQLTemplateFormState | InitializedSQLTemplateFormState;

export interface SQLTemplateFormComponentProps {
  sqlTemplateFormState: SQLTemplateFormState;
  setSelectedTable: (selectedTable: WarehouseTableData) => void;
  setExcludeDuplicates: (excludeDuplicates: boolean) => void;
  updateColumnFilters: (columnFilters: Array<ColumnFilter>) => void;
  updateColumnState: (columnIndex: number, columnProperties: AvailableColumnProperties) => void;
  updateAllColumnStates: (columnProperties: AvailableColumnProperties) => void;
  updateColumnStatesInRange: (
    startIndex: number,
    stopIndex: number,
    columnProperties: AvailableColumnProperties
  ) => void;
}

export function isFormStateInitialized(
  sqlTemplateFormState: SQLTemplateFormState
): sqlTemplateFormState is InitializedSQLTemplateFormState {
  return sqlTemplateFormState.selectedTable != null;
}

export function assertIsFormStateInitialized(
  sqlTemplateFormState: SQLTemplateFormState
): asserts sqlTemplateFormState is InitializedSQLTemplateFormState {
  if (!isFormStateInitialized(sqlTemplateFormState)) {
    assert(false, 'Expected selectedTable to not be null');
  }
}
